// extracted by css-extract-rspack-plugin
export default {"divider":"divider-IRjheg","horizontal":"horizontal-d6B7O6","vertical":"vertical-_EJhJ1"};